import styled from 'styled-components';

export const Container = styled.div`
  margin-bottom: 0.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  width: 100%;
`;

export const TitleWrapper = styled.div`
  display: flex;
  align-items: baseline;

  h2 {
    color: #4d4d4d;
    font-weight: 400;
    margin: 0;
    margin-right: 0.3rem;
  }
`;

export const ChartSkeleton = styled.div`
  display: flex;
  flex-direction: row;
  gap: 2.1rem;
  justify-content: center;
  height: 400px;
  transform: rotate(180deg);
`;
